export default "__VITE_ASSET__12d9123d__"